import { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { SnapPointMode } from "mapbox-gl-draw-snap-mode";

import { handleSnapMouseMove } from "./helper";
import { DEFAULT_SNAP_PREVIEW_STYLE, ensurePreviewCircleLayer, removePreviewLayer } from "./snapPreview";

const SNAP_PREVIEW_SOURCE_ID = "snap-point-preview-source";
const SNAP_PREVIEW_LAYER_ID = "snap-point-preview-layer";

/**
 * Custom SnapPointMode that uses snapWithPointPriority to prioritize
 * snapping to Points over LineStrings/Polygons, and shows a visual
 * preview when snapping occurs.
 */
const CustomSnapPointMode: DrawCustomMode = {
  ...SnapPointMode,

  onSetup: function (opts) {
    const state = SnapPointMode.onSetup?.call(this, opts) ?? {};

    // Setup snap preview layer
    ensurePreviewCircleLayer(this.map, SNAP_PREVIEW_SOURCE_ID, SNAP_PREVIEW_LAYER_ID, DEFAULT_SNAP_PREVIEW_STYLE);

    return state;
  },

  onMouseMove: function (state, e) {
    return handleSnapMouseMove(this, SnapPointMode, state, e, SNAP_PREVIEW_SOURCE_ID);
  },

  onStop: function (state) {
    // Clean up the snap preview layer
    removePreviewLayer(this.map, SNAP_PREVIEW_SOURCE_ID, SNAP_PREVIEW_LAYER_ID);

    // Call parent onStop if it exists
    if (SnapPointMode.onStop) {
      return SnapPointMode.onStop.call(this, state);
    }
  },
};

export default CustomSnapPointMode;
